import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";

const Layout = () => {
  const location = useLocation();

  // Paths that shouldn't show regular header/footer
  const noHeaderFooterPaths = ["/login", "/register", "/forgot-password"];

  // Dashboard paths
  const dashboardPaths = [
    "/AdminDashboard",
    "/SupplierDashboard",
    "/RenterDashboard",
  ];
  const isDashboardRoute = dashboardPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  const shouldShowHeaderFooter = !noHeaderFooterPaths.includes(
    location.pathname
  );

  return (
    <Fragment>
      {isDashboardRoute ? (
        <Routers /> // Let the nested routes handle dashboard layout
      ) : (
        <>
          {shouldShowHeaderFooter && <Header />}
          <div>
            <Routers />
          </div>
          {shouldShowHeaderFooter && <Footer />}
        </>
      )}
    </Fragment>
  );
};

export default Layout;
